export const XQ_PIECES = Object.freeze({
  K: '帥', A: '仕', E: '相', H: '傌', R: '俥', C: '炮', P: '兵',
  k: '將', a: '士', e: '象', h: '馬', r: '車', c: '砲', p: '卒'
});

export const DIFFICULTY = Object.freeze({
  1: 'Máy đi ngẫu nhiên, phù hợp người mới.',
  2: 'Ưu tiên nước ăn quân nhưng vẫn mắc lỗi.',
  3: 'Cân bằng giữa tốc độ và khả năng tính toán.',
  4: 'Ít sai lầm hơn, phù hợp người chơi khá.',
  5: 'Tính sâu hơn; có thể mất thêm thời gian mỗi lượt.'
});

export const GAME_CATALOG = Object.freeze({
  chess: { title: 'Cờ vua', kicker: 'CỜ VUA', modes: ['bot', 'local', 'online'] },
  xiangqi: { title: 'Cờ tướng', kicker: 'CỜ TƯỚNG', modes: ['bot', 'local', 'online'] },
  caro: {
    title: 'Cờ ca-rô',
    kicker: 'CỜ CA-RÔ',
    modes: ['bot', 'local', 'online'],
    modeCopy: {
      bot: '5 cấp độ · Đánh X trước · Không cần mạng',
      local: '2 người luân phiên X / O trên bàn 15 × 15',
      online: 'LIVE 2 thiết bị · X / O · Server-authoritative'
    }
  },
  tycoon: {
    title: 'Cờ tỷ phú',
    kicker: 'CỜ TỶ PHÚ',
    modes: ['local', 'online'],
    modeCopy: {
      local: '40 ô Nam → Bắc · VND · 2–4 người · Xây nhà/khách sạn',
      online: 'LIVE 2–4 thiết bị · Tạo phòng/Vào phòng · Server-authoritative'
    }
  }
});
